import React from 'react'
import { Link } from 'react-router-dom'

const Offers = () => {
    return (
        <>
            <section className="banners mb-25 " style={{ marginTop: "50px" }}>
                <div className="container">
                    <div className="row">
                        <div className="section-title">
                            <div className="title mb-3">
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-3">
                            <div className="banner-img wow animate__animated animate__fadeInUp" data-wow-delay={0}>
                                <img src="assets/imgs/banner/banner-20.jpg" alt />
                                <div className="banner-text">
                                    <h4 className='text-white'>
                                        Stone is a solid, natural, and durable material.
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="banner-img wow animate__animated animate__fadeInUp" data-wow-delay=".2s">
                                <img src="assets/imgs/banner/banner-21.jpg" alt />
                                <div className="banner-text">
                                    <h4 className='text-white'>
                                        Stone is a strong, natural material.
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 d-md-none d-lg-flex mb-3">
                            <div className="banner-img mb-sm-0 wow animate__animated animate__fadeInUp" data-wow-delay=".4s">
                                <img src="assets/imgs/banner/banner-23.jpg" alt />
                                <div className="banner-text">
                                    <h4 className='text-white'>
                                        Stone is a timeless, natural solid.
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Offers